module.exports = __webpack_public_path__ + "static/img/azapp.2486763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/azapp.jpg
// module id = Nrod
// module chunks = 1